 //-------------------Image Touch Slider------------------------//
 $('.imageTouchSlider .slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    dots: true,
    autoplay: true,
    arrows: true,
    prevArrow: '<a class="slick-prev" href="#"><i class="fa fa-angle-left"></i></a>',
    nextArrow: '<a class="slick-next" href="#"><i class="fa fa-angle-right"></i></a>',
    autoplaySpeed: 800,
    autoplaySpeed: 8000,
    pauseOnDotsHover: true,
    appendDots: $(".imageTouchSlider__img"),
    customPaging: function (slick, index) {
        var target = slick.$slides.eq(index).attr('data-location');;
        return '<div class="dot ' + target + '"></div>';
    }
});
//------------------ End Image Touch Slider---------------------//